import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createVenue,
  deleteVenue,
  partialVenueUpdate,
  selectSelectedVenue,
} from '@store/VenueReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

const VenueForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.venue)
  const selectedVenue = useAppSelector(selectSelectedVenue())

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) => {
          delete values.venueAuthorization
          return dispatch(createVenue(values)).then(() => true)
        },
        update: async (values) => {
          if (!selectedVenue) {
            return Promise.resolve(false)
          }
          delete values.venueAuthorization
          return dispatch(partialVenueUpdate(selectedVenue, values)).then(
            () => true
          )
        },

        delete: async (values) =>
          dispatch(deleteVenue(values)).then(() => true),
      }}
    />
  )
})

VenueForm.displayName = 'VenueForm'

export default VenueForm
